import React, { useState, useEffect } from "react";
import HomeFourthSectionCard from "../components/HomeFourthSectionCard";
import HomeFourthSectionCanvas from "../components/HomeFourthSectionCanvas";
import TextAnimH1 from "../components/TextAnimH1";
import TextAnimP1 from "../components/TextAnimP1";
import TextAnimation from "../components/TextAnimation";
import ParticleEffect from "../components/Svg_particle_effect";
import webDevLottie from "../animation/web-dev.json"
import strat from "../animation/try.json"

const content = [
  {
    title: "Pro-Strategist ",
    h2: "DEVELOPMENT",
    dHead: `Solutions that <br /> deliver your future.`,
    dParagraph: `We as a digital marketing agency in the US help brands to grow smarter and faster through SEO, strategy and sharp campaigns.`,
    lottieSrc: webDevLottie
  },
  {
    title: "Pro-Strategist ",
    h2: "CORE-STRATEGY",
    dHead: `Strategies that <br /> reflect who you are.`,
    dParagraph: `  We create customized online reputation management services and strategies that optimise technology for managing processes with high efficiency and sustainable growth.`,
    lottieSrc: strat
  },
];

const HomeFourthSection = () => {
  const [isXlScreen, setIsXlScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsXlScreen(window.innerWidth >= 1280);
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div className=" pointer-events-auto">
      <TextAnimP1>
        
        <div className="min-h-screen w-full  relative overflow-hidden flex flex-col xl:flex-row xl:items-start justify-center xl:gap-[30vw] xl:px-35 mt-20 px-10 gap-[100vh] ">
          {/* <HomeFourthSectionCanvas /> */}
          <ParticleEffect />

          {content.map((item, index) => (
            <HomeFourthSectionCard
              key={index}
              align={window.innerWidth >= 1280 ? (index % 2 === 0 ? "left" : "right") : ""}
              content={item}
            />
          ))}
        </div>
      </TextAnimP1>
    </div>
  );
};

export default HomeFourthSection;
